var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { replaceEmpty } from '@lhb/func';
import { checkIsColor } from 'src/common/utils/tools';
var ColorText = /** @class */ (function (_super) {
    __extends(ColorText, _super);
    function ColorText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ColorText.prototype, "colorValue", {
        // 颜色键名对应的值，如果是颜色值的格式（如 #fff，rgb(xxx)）. 使用 colorStyle，否则使用 colorClass
        get: function () {
            return this.$props.colorMap[replaceEmpty(this.colorKey, this.value.toString())];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorText.prototype, "colorClass", {
        // 颜色选择器
        get: function () {
            return this.$props.colorMap[this.colorKey];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorText.prototype, "colorStyle", {
        // 颜色样式
        get: function () {
            return checkIsColor(this.colorValue) ? { 'background-color': this.colorValue } : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorText.prototype, "textColorStyle", {
        // 颜色样式
        get: function () {
            return checkIsColor(this.colorValue) ? { 'color': this.colorValue } : '';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            type: [String, Number],
            default: '',
        })
    ], ColorText.prototype, "value", void 0);
    __decorate([
        Prop({
            type: [String, Number],
            default: null,
        })
    ], ColorText.prototype, "colorKey", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return {};
            },
        })
    ], ColorText.prototype, "colorMap", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true,
        })
    ], ColorText.prototype, "dot", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false,
        })
    ], ColorText.prototype, "isTextColor", void 0);
    ColorText = __decorate([
        Component
    ], ColorText);
    return ColorText;
}(Vue));
export default ColorText;
